import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {kitsProductsUpdateTableReady,rowsPerPageState,searchTextState,paginationState} from '../redux/kits'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/productKits.css'

//import * as Helpers from '../../../common/helpers'

function filterUnwantedData(kitProductsData) {
    let array = []
    if (kitProductsData && kitProductsData.data && kitProductsData.data.list) {
        array = kitProductsData.data.list
    }

    let newArray = []
    let noProductsArray = []
    let productsArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let lineData = array[i]
            
           if(lineData.kit_products.length>0){
                lineData.existing=1
                lineData.checked=true
                lineData.quantity=lineData.kit_products[0].quantity
                lineData.sequence=lineData.kit_products[0].sequence
                lineData.estimated_cost=lineData.kit_products[0].estimated_cost
                lineData.kit_product_id=lineData.kit_products[0].kit_product_id
                lineData.base_quantity=lineData.kit_products[0].base_quantity
                lineData.status=lineData.kit_products[0].status
                productsArray.push(lineData)
           }else{
                lineData.checked=false
                lineData.existing=0
                lineData.quantity=0
                lineData.sequence=0
                lineData.estimated_cost=0
                lineData.kit_product_id=0
                lineData.base_quantity=0
                lineData.status="ACTIVE"
                noProductsArray.push(lineData)
           }

        
        }
    }

    productsArray.sort((a,b) => (a.sequence > b.sequence) ? 1 : ((b.sequence > a.sequence) ? -1 : 0))

    newArray=productsArray.concat(noProductsArray)
    return newArray
}


class KitsProductsUpdateTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            kitsProductsData: [],
            initialKitsProductsData: [],
            productSelected:{},
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(kitsProductsUpdateTableReady(false))

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getRestaurantLocationData()        
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getRestaurantLocationData = () => {


         if(this.props.kits && this.props.kits.productSelected && this.props.kits.productSelected !== null){
            //this.props.dispatch(headerDataUpdate(this.props.kits.productSelected.sku_name+" - Update Products"))


            this.props.dispatch(headerDataUpdate(Constants.KITS_PRODUCTS_UPDATE_TABLE))
            this.props.dispatch(subHeaderDataUpdate(" - "+this.props.kits.productSelected.sku_name))

            let prevProductData= this.props.kits.productSelected                
                        this.setState({
                            productSelected:prevProductData
                        })

        apiService.listMarkedProducts(this.props.kits.productSelected.id)
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.kits && this.props.kits.previousPaginationValue) {
                            pageNo = this.props.kits.previousPaginationValue
                        }
                        this.setState({
                            kitsProductsData: array,
                            initialKitsProductsData : array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(kitsProductsUpdateTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(kitsProductsUpdateTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })

        }
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.kits && this.props.kits.previousRowsPerPageValue) {
            value = this.props.kits.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   
                   <div className="col-xs-12 col-sm-12 col-md-10 header-div-margins">
                            <a href="" 
                                onClick={(e) => {e.preventDefault() 
                                            this.props.history.goBack()}}> 
                                    <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                            </a>
                    </div>

                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                   <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.updateKitProducts()
                            }}>
                            Update KIT Products
                        </button>
                    </div>

                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return (
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 footer-pagination-icons">
                    {props.components.pageList}
                </div>
            </div>
        )
    }

    getFilteredBrandList = () => {
       
        this.props.dispatch(kitsProductsUpdateTableReady(false))
        this.resetSearchAndPagination()
        this.getRestaurantLocationData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getRestaurantLocationData()
        this.props.dispatch(kitsProductsUpdateTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }

    updateKitProducts = () => {

    this.props.dispatch(kitsProductsUpdateTableReady(false))

    let kitsProductsData=this.state.kitsProductsData.slice();

    //let initialKitsProductsData=this.state.initialKitsProductsData.slice();


    let added=[]
    let removed=[]
    let updated=[]

         kitsProductsData.map(function(item) {
            if(item.checked===1 && !item.existing){
                let obj={
                    "product_id":item.product_id,
                    "sequence":item.sequence,
                    "quantity":item.quantity,
                    "estimated_cost":item.estimated_cost,
                    "base_quantity":item.base_quantity,
                    "status":item.status
                }
                added.push(obj)
            }else if(item.existing===1 && !item.checked){
                let obj={"kit_product_id":item.kit_products[0].kit_product_id}
                removed.push(obj)
            }else if(item.existing===1 && item.checked){
                // initialKitsProductsData.map(function(item2) {
                //      if(item2.checked===1 && item2.existing===1){
                //         if(item.kit_products[0].kit_product_id===item2.kit_products[0].kit_product_id){
                //             if(item.sequence!=item2.sequence || item.quantity!=item2.quantity || item.estimated_cost!=item2.estimated_cost || item.base_quantity!=item2.base_quantity || item.status!=item2.status ){

                //                  let obj={
                //                     "product_id":item.product_id,
                //                     "sequence":item.sequence,
                //                     "quantity":item.quantity,
                //                     "estimated_cost":item.estimated_cost,
                //                     "base_quantity":item.base_quantity,
                //                     "status":item.status
                //                 }
                //                 updated.push(obj)
                //             }
                //         }
                //      }
                //  })

                        let obj={
                                    "product_id":item.product_id,
                                    "sequence":item.sequence,
                                    "quantity":item.quantity,
                                    "estimated_cost":item.estimated_cost,
                                    "base_quantity":item.base_quantity,
                                    "status":item.status,
                                    "kit_product_id":item.kit_products[0].kit_product_id
                                }
                                updated.push(obj)

            }  

            return true
        })




        let apiPayloadData={
            "kit_product_list":{
                added,
                removed,
                updated
            }}


        apiService.postProductsKitsUpdate(apiPayloadData,this.state.productSelected.id)
            .then(responseData => {
                 this.props.dispatch(kitsProductsUpdateTableReady(true))
                    if (responseData.status === "SUCCESS") {
                        window.location.reload()
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                console.error("Error data: ", err)
               alert("exception");
            })
        
    }


       checkBoxChange = (row,e,rowIndex) => {

        let prodKitsData=this.state.kitsProductsData.slice();
            //prodKitsData[rowIndex]['checked']=e.target.checked
           

            prodKitsData.map(function(item) {
                if(item.product_id===row.product_id){
                    item['checked']=e.target.checked
                    return true;
                }
                return true
            });

             this.setState({
                kitsProductsData:prodKitsData
             })
        }

        inputChange = (row,e,rowIndex,field_name) => {

        let prodKitsData=this.state.kitsProductsData.slice();
           
             prodKitsData.map(function(item) {
                if(item.product_id===row.product_id){
                    item[field_name]=e.target.value
                    return true;
                }

                return true
            });

             this.setState({
                kitsProductsData:prodKitsData
             })
        }
        
    

    renderCheckBox = (cell, row, enumObject, rowIndex) => {
        //debugger;
        let checkBox=<input className="checkbox" type="checkbox" value={row.restaurant_id} onChange={(e) => {
                     this.checkBoxChange(row,e,rowIndex)
                }} checked={row.checked}/>
        
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{checkBox}</div>
        </div>)
    }


renderSequenceInput = (cell, row, enumObject, rowIndex) => {
        //debugger;
        let inputElem=<input className="form-control" type="number" placeholder="Enter Sequence" value={row.sequence} onChange={(e) => {e.preventDefault();
                     this.inputChange(row,e,rowIndex,"sequence")
                }} readOnly={!row.checked}/>
        
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{inputElem}</div>
        </div>)
    }

    renderQuantitiyInput = (cell, row, enumObject, rowIndex) => {
        //debugger;
        let inputElem=<input className="form-control" type="number" placeholder="Enter Quantity" value={row.quantity} onChange={(e) => {e.preventDefault();
                     this.inputChange(row,e,rowIndex,"quantity")
                }} readOnly={!row.checked}/>
        
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{inputElem}</div>
        </div>)
    }
    renderBaseQuantitiyInput = (cell, row, enumObject, rowIndex) => {
        //debugger;
        let inputElem=<input className="form-control" type="number" placeholder="Enter Base Quantity" value={row.base_quantity} onChange={(e) => {e.preventDefault();
                     this.inputChange(row,e,rowIndex,"base_quantity")
                }} readOnly={!row.checked}/>
        
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{inputElem}</div>
        </div>)
    }
    renderEstimatedQuantityInput = (cell, row, enumObject, rowIndex) => {
        //debugger;
        let inputElem=<input className="form-control" type="number" placeholder="Enter Estimated Cost" value={row.estimated_cost} onChange={(e) => {e.preventDefault();
                     this.inputChange(row,e,rowIndex,"estimated_cost")
                }} readOnly={!row.checked}/>
        
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{inputElem}</div>
        </div>)
    }

    renderStatusInput = (cell, row, enumObject, rowIndex) => {
        //debugger;
                let inputElem=<select className="selectpicker" value={row.status} onChange={(e) => {e.preventDefault();
                     this.inputChange(row,e,rowIndex,"status")
                }} disabled={!row.checked}>
                  <option value="ACTIVE">ACTIVE</option>
                  <option value="IN ACTIVE">IN ACTIVE</option>
                </select>

        
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{inputElem}</div>
        </div>)
    }



    




     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.kits && this.props.kits.previousPaginationValue
            && this.props.kits.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editBrand = (row) => {
        // if (row && row.id) {
        //     this.props.dispatch(brandIdForAction(row.id))
        //     this.props.history.push("/dashboard/brand/addedit")
        // } else {
        //     this.dialog.show({
        //         title: "Brand Identification number not found",
        //         body: 'Brand id is not available, So not able edit brand',
        //         actions: [
        //             Dialog.OKAction(() => {
        //             })
        //         ],
        //     })
        // }
    }

    render() {
        let sizeperPage = 15

        if (this.props.kits && this.props.kits.previousRowsPerPageValue) {
            sizeperPage = this.props.kits.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (

            <div className="product-location-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                        
                <Dialog ref={el => this.dialog = el} />
                    <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.kitsProductsData}
                    pagination={false}
                    hover={true}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}
                   >
                    <TableHeaderColumn
                        dataField="product_id"
                        width="1"
                        isKey={true}
                        hidden={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Id
                    </TableHeaderColumn>
                      <TableHeaderColumn
                        dataFormat={this.renderCheckBox}
                        dataAlign='center'
                        width="50"
                        tdStyle={{ whiteSpace: 'normal' }}>
                        
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="sku_number"
                       
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        SKU Number
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="product_name"    
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Description
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        //dataField="sequence"
                         dataFormat={this.renderSequenceInput}
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Sequence
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        //dataField="quantity"
                        dataFormat={this.renderQuantitiyInput}
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Quantity
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        //dataField="base_quantity"
                        dataFormat={this.renderBaseQuantitiyInput}
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Base Quantity
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        //dataField="estimated_cost"
                        dataFormat={this.renderEstimatedQuantityInput}
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Estimated Cost
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        //dataField="status"
                        dataFormat={this.renderStatusInput}
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Status
                    </TableHeaderColumn>

                </BootstrapTable>

            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        kits: state.kits
    }
}

export default connect(mapStateToProps)(withRouter(KitsProductsUpdateTable))


// WEBPACK FOOTER //
// ./src/modules/Kits/Components/KitsProductsUpdateTable.js